module.exports = __webpack_public_path__ + "static/media/flask-potion.2ba81455.svg";